"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cart_to_cart_1 = __importDefault(require("./cart-to-cart"));
var cart_add_to_cart_1 = __importDefault(require("./cart-add-to-cart"));
var cart_to_checkout_1 = __importDefault(require("./cart-to-checkout"));
var constants_1 = require("./constants");
var cookie_utility_1 = require("../../utility/cookie_utility");
var Cart = /** @class */ (function () {
    function Cart() {
    }
    Cart.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Cart.cartObj = this;
                        this.productSectionElement = document.querySelector("[".concat(constants_1.PRODUCTS_SECTION, "]"));
                        this.headerCartCount = document.querySelector("[".concat(constants_1.DATA_CART_ITEMS, "]"));
                        return [4 /*yield*/, this.updateCartCount()];
                    case 1:
                        _a.sent();
                        if (!this.productSectionElement) return [3 /*break*/, 3];
                        this.ajaxAddToCart = this.productSectionElement.getAttribute('data-ajax-cart');
                        this.ajaxCart = this.productSectionElement.getAttribute(constants_1.DATA_GET_CART);
                        this.toCart = new cart_to_cart_1.default();
                        this.toCart.init();
                        this.addToCart = new cart_add_to_cart_1.default();
                        this.addToCart.init();
                        return [4 /*yield*/, this.addToCart.updateCartItemBadge()];
                    case 2:
                        _a.sent();
                        this.toCheckout = new cart_to_checkout_1.default();
                        this.toCheckout.init();
                        return [3 /*break*/, 4];
                    case 3:
                        this.checkCartCountOnInit();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.updateCartCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!cookie_utility_1.CookieUtility.getCookie(constants_1.SW_COOKIE_CART_COUNT)) return [3 /*break*/, 2];
                        return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie(constants_1.SW_COOKIE_CART_COUNT, '0', 1)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.headerCartCount.innerHTML = cookie_utility_1.CookieUtility.getCookie(constants_1.SW_COOKIE_CART_COUNT);
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.checkCartCountOnInit = function () {
        this.headerCartCount.innerHTML = cookie_utility_1.CookieUtility.getCookie(constants_1.SW_COOKIE_CART_COUNT);
        var count = parseInt(this.headerCartCount.innerHTML);
        var cartEmpty = document.querySelector("[".concat(constants_1.DATA_CART_EMPTY, "]"));
        var cartFilled = document.querySelector("[".concat(constants_1.DATA_CART_FILLED, "]"));
        if (count > 0) {
            cartEmpty.classList.add('d-none');
            cartFilled.classList.remove('d-none');
        }
        else {
            cartEmpty.classList.remove('d-none');
            cartFilled.classList.add('d-none');
        }
    };
    Cart.prototype.getAjaxAddToCartUrl = function () {
        return this.ajaxAddToCart;
    };
    Cart.prototype.getAjaxCart = function () {
        return this.ajaxCart;
    };
    return Cart;
}());
exports.default = Cart;
